// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fqHu","delete":"styles_delete__Ve5_2","update":"styles_update__29KUS","add":"styles_add__D5Nd0"};